import { useQuery } from '@apollo/client';
import { GRAPHQL_LISTAR_PERIODO } from 'gql/periodo';
import { useMemo } from 'react';

export const usePeriodoOptions = () => {
    const { data } = useQuery<{
        periodo?: { id: string; nome: string }[];
    }>(GRAPHQL_LISTAR_PERIODO);

    const periodoOptions = useMemo(() => {
        return [
            { value: '', label: 'Selecione' },
            ...(data?.periodo || []).map(({ id, nome }) => ({
                value: id,
                label: nome,
            })),
        ];
    }, [data]);

    return periodoOptions;
};
